<template>
    <div class="p-3">
        <h3>RL 5.1 Kompilasi Morbiditas Pasien Rawat Jalan</h3>
        <hr />

        <DataTable
            table-id="table-pasien"
            title="Kompilasi Morbiditas Pasien Rawat Jalan"
            :filter-configs="filterConfigs"
            :table-options="tableOptions"
            :show-filter="true"
        />
    </div>
</template>

<script>
import DataTable from "@/components/global/DataTable.vue";

export default {
    components: {
        DataTable,
    },

    data() {
        return {
            filterConfigs: [
                {
                    id: "start_date",
                    label: "Tanggal Awal",
                    field: "start_date",
                    type: "date",
                    colClass: "col-sm-3",
                    component: "",
                },
                {
                    id: "end_date",
                    label: "Tanggal Akhir",
                    field: "end_date",
                    type: "date",
                    colClass: "col-sm-3",
                    component: "",
                },
            ],

            tableOptions: {
                pagination: true,
                paginationMode: "remote",
                paginationSize: 500,
                paginationSizeSelector: [20, 50, 100, 250, 500],
                baseUrl: "/api/rekapitulasi-morbiditas/morbiditas-rajal",
                layout: "fitData",
                height: "600px",

                columns: [
                    {
                        title: "Kode ICD-10",
                        field: "kode_icd",
                        width: 120,
                        frozen: true,
                    },
                    {
                        title: "Diagnosis Penyakit",
                        field: "diagnosa",
                        width: 350,
                        frozen: true,
                    },
                    {
                        title: "Jumlah Kasus Baru Menurut Kelompok Umur & Jenis Kelamin",
                        columns: [
                            {
                                title: "< 1 Jam",
                                columns: [
                                    {
                                        title: "L",
                                        field: "a_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "a_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "1-23 Jam",
                                columns: [
                                    {
                                        title: "L",
                                        field: "b_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "b_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "1-7 Hari",
                                columns: [
                                    {
                                        title: "L",
                                        field: "c_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "c_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "8-28 Hari",
                                columns: [
                                    {
                                        title: "L",
                                        field: "d_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "d_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "29 Hari - <3 Bln",
                                columns: [
                                    {
                                        title: "L",
                                        field: "e_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "e_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "3 - <6 Bln",
                                columns: [
                                    {
                                        title: "L",
                                        field: "f_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "f_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "6-11 Bln",
                                columns: [
                                    {
                                        title: "L",
                                        field: "g_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "g_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "1-4 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "h_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "h_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "5-9 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "i_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "i_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "10-14 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "j_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "j_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "15-19 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "k_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "k_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "20-24 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "l_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "l_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "25-29 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "m_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "m_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "30-34 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "n_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "n_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "35-39 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "o_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "o_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "40-44 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "p_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "p_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "45-49 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "q_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "q_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "50-54 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "r_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "r_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "55-59 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "s_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "s_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "60-64 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "t_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "t_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "65-69 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "u_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "u_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "70-74 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "v_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "v_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "75-79 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "w_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "w_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "80-84 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "x_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "x_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                            {
                                title: "≥85 Th",
                                columns: [
                                    {
                                        title: "L",
                                        field: "y_l",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                    {
                                        title: "P",
                                        field: "y_p",
                                        hozAlign: "center",
                                        width: 50,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        title: "Jumlah Kasus Baru Menurut Jenis Kelamin",
                        columns: [
                            {
                                title: "L",
                                field: "kasus_baru_l",
                                hozAlign: "center",
                                width: 60,
                            },
                            {
                                title: "P",
                                field: "kasus_baru_p",
                                hozAlign: "center",
                                width: 60,
                            },
                            {
                                title: "Total",
                                field: "kasus_baru_total",
                                hozAlign: "center",
                                width: 70,
                            },
                        ],
                    },
                    {
                        title: "Jumlah Kasus Lama Menurut Jenis Kelamin",
                        columns: [
                            {
                                title: "L",
                                field: "kasus_lama_l",
                                hozAlign: "center",
                                width: 60,
                            },
                            {
                                title: "P",
                                field: "kasus_lama_p",
                                hozAlign: "center",
                                width: 60,
                            },
                            {
                                title: "Total",
                                field: "kasus_lama_total",
                                hozAlign: "center",
                                width: 70,
                            },
                        ],
                    },
                    {
                        title: "Total Kasus Baru + Lama",
                        columns: [
                            {
                                title: "L",
                                field: "total_baru_lama_l",
                                hozAlign: "center",
                                width: 60,
                            },
                            {
                                title: "P",
                                field: "total_baru_lama_p",
                                hozAlign: "center",
                                width: 60,
                            },
                            {
                                title: "Total",
                                field: "total_baru_lama",
                                hozAlign: "center",
                                width: 70,
                            },
                        ],
                    },
                    {
                        title: "Jumlah Kunjungan",
                        columns: [
                            {
                                title: "L",
                                field: "kunjungan_l",
                                hozAlign: "center",
                                width: 60,
                            },
                            {
                                title: "P",
                                field: "kunjungan_p",
                                hozAlign: "center",
                                width: 60,
                            },
                            {
                                title: "Total",
                                field: "total_kunjungan",
                                hozAlign: "center",
                                width: 70,
                            },
                        ],
                    },
                ],
            },
        };
    },
};
</script>
